import { from, throwError as observableThrowError, Observable } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpHeaders, HttpInterceptor } from '@angular/common/http';
import { AuthenticationService } from '../authentication/authentication.service';
import { shouldAttachToken } from '../authentication/msal.config';

@Injectable()
export class AuthHttpInterceptor implements HttpInterceptor {
    constructor(
        private _authService: AuthenticationService,
    ) {
    }

    private _authHeaders(access_token: string, token_type = 'Bearer'): HttpHeaders {
        return new HttpHeaders()
            .append('Authorization', token_type + ' ' + access_token)
            .append('Content-Type', 'application/json');
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Signed-out requests and third-party hosts go out without a token.
        if (!this._authService.isAuthenticated || !shouldAttachToken(request.url)) {
            return next.handle(request);
        }
        // Like ADAL: every request gets the token and its headers replaced.
        return from(this._authService.getTokenForUrl(request.url)).pipe(
            mergeMap(token => next.handle(request.clone({ headers: this._authHeaders(token) }))),
            catchError(this.handleError)
        );
    }

    private handleError(error: any) {
        return observableThrowError(error);
    }
}
